import {
  MS_PER_DAY,
  MS_PER_HOUR,
  MS_PER_MINUTE,
  MS_PER_SECOND,
} from "@/constants";

export function getTimeDistance(countDownDate: number) {
  return countDownDate - Date.now();
}

export function getTimeDistanceDigits(distance: number) {
  if (distance < 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(distance / MS_PER_DAY);
  const hours = Math.floor((distance % MS_PER_DAY) / MS_PER_HOUR);
  const minutes = Math.floor((distance % MS_PER_HOUR) / MS_PER_MINUTE);
  const seconds = Math.floor((distance % MS_PER_MINUTE) / MS_PER_SECOND);

  return { days, hours, minutes, seconds };
}

export function getUTCTime(date: string, time?: string) {
  const newDate = new Date(date);
  const timeArray = time?.split(":");

  if (isNaN(newDate.getTime())) {
    throw new Error("Invalid date");
  }

  if (timeArray?.length === 2) {
    const hours = Number(timeArray[0]);
    const minutes = Number(timeArray[1]);

    if (isNaN(hours) || isNaN(minutes)) {
      throw new Error("Invalid time format. Expected 'HH:MM'");
    }

    newDate.setUTCHours(hours);
    newDate.setUTCMinutes(minutes);
  }

  return newDate.getTime();
}
